import React from 'react';
import { ChevronRightIcon, SparklesIcon, CheckCircleIcon, DollarSignIcon } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
export function HeroSection() {
  // Handle add to cart event
  const handleAddToCart = () => {
    trackPixelEvent('AddToCart', {
      value: 11955,
      currency: 'ARS',
      content_name: 'Método Milhojas Perfecta',
      content_ids: ['M101869446L'],
      content_type: 'product'
    });
  };
  return <section className="pt-24 pb-12 md:pt-28 md:pb-16 text-center" data-id="element-145">
      <div className="max-w-3xl mx-auto" data-id="element-146">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-amber-900 mb-6" data-id="element-147">
          El secreto de las capas crocantes, el dulce de leche cremoso y el
          merengue brillante… al alcance de tu cocina.
        </h2>
        <div className="bg-amber-100 rounded-lg p-4 mb-8" data-id="element-148">
          <div className="aspect-square overflow-hidden rounded-lg" data-id="element-149">
            <picture data-id="element-150">
              <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/rs1PfDpsHpNjfjEQjjjS8x/ChatGPT_Image_Sep_2%2C_2025%2C_09_14_42_PM.png" media="(min-width: 768px)" width="800" height="800" data-id="element-151" />
              <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/rs1PfDpsHpNjfjEQjjjS8x/ChatGPT_Image_Sep_2%2C_2025%2C_09_14_42_PM.png" media="(min-width: 320px)" width="400" height="400" data-id="element-152" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rs1PfDpsHpNjfjEQjjjS8x/ChatGPT_Image_Sep_2%2C_2025%2C_09_14_42_PM.png" alt="Deliciosa Milhojas Perfecta con capas crocantes y merengue italiano" className="w-full h-full object-cover" loading="eager" fetchpriority="high" width="800" height="800" decoding="async" data-id="element-153" />
            </picture>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-154">
          <a href="#comprar" className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-full text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-155">
            Quiero Aprender a Hacer la Milhojas
            <ChevronRightIcon size={18} data-id="element-156" />
          </a>
          <a href="#testimonios" className="bg-white hover:bg-gray-100 text-amber-800 border border-amber-300 font-bold py-3 px-6 rounded-full text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-157">
            Ver Testimonios
            <ChevronRightIcon size={18} data-id="element-158" />
          </a>
        </div>
        {/* Income Section Content */}
        <div className="max-w-3xl mx-auto px-4 mt-12" data-id="element-159">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-160">
            <div className="bg-amber-600 p-5 text-white" data-id="element-161">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-center" data-id="element-162">
                Aprende a hacer la torta que todos quieren comprar…
              </h2>
            </div>
            <div className="p-6" data-id="element-163">
              <p className="text-lg text-gray-700 mb-8 text-center" data-id="element-164">
                y conviértela en tu fuente de ingresos.
              </p>
              <div className="flex items-center justify-center gap-3 mb-8" data-id="element-165">
                <div className="bg-amber-100 p-3 rounded-full" data-id="element-166">
                  <DollarSignIcon size={28} className="text-amber-600" data-id="element-167" />
                </div>
                <p className="text-lg font-medium text-gray-800" data-id="element-168">
                  ¿Sabías que cada milhojas se vende por $100 dólares?
                </p>
              </div>
              <p className="text-gray-700 mb-8" data-id="element-169">
                Imagina el poder de dominar esta receta: no solo tendrás un
                postre digno de pastelería profesional en tu mesa, sino también
                un producto listo para generar ingresos desde tu cocina.
              </p>
              <div className="mb-6 flex items-start gap-4" data-id="element-170">
                <div className="flex-shrink-0 mt-1" data-id="element-171">
                  <SparklesIcon size={22} className="text-amber-600" data-id="element-172" />
                </div>
                <p className="text-gray-700" data-id="element-173">
                  <span className="font-medium text-amber-800" data-id="element-174">
                    El secreto de las capas crocantes
                  </span>
                  , el dulce de leche cremoso y el merengue brillante… ahora al
                  alcance de tus manos.
                </p>
              </div>
              <div className="mb-4 flex items-start gap-4" data-id="element-175">
                <div className="flex-shrink-0 mt-1" data-id="element-176">
                  <CheckCircleIcon size={22} className="text-amber-600" data-id="element-177" />
                </div>
                <p className="text-gray-700" data-id="element-178">
                  <span className="font-medium text-amber-800" data-id="element-179">
                    Milhojas perfecta
                  </span>{' '}
                  en textura, sabor y presentación.
                </p>
              </div>
              <div className="mb-6 flex items-start gap-4" data-id="element-180">
                <div className="flex-shrink-0 mt-1" data-id="element-181">
                  <CheckCircleIcon size={22} className="text-amber-600" data-id="element-182" />
                </div>
                <p className="text-gray-700" data-id="element-183">
                  Con un método que te permite{' '}
                  <span className="font-medium text-amber-800" data-id="element-184">
                    vender cada torta a un precio premium
                  </span>
                  .
                </p>
              </div>
              <div className="text-center" data-id="element-185">
                <a href="#comprar" className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors shadow-md" data-id="element-186">
                  ¡Quiero Aprender!
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}